import { UserService } from './user.service';

export const services = [UserService];

export * from './user.service';
